module.exports = __webpack_public_path__ + "fonts/8bdf70ecc5e367c11aeaca909df5c7b3.txt";